import React from "react";
import Modal from "react-bootstrap/Modal";

const ModalCloneConfirmation = ({ show, onConfirm, onClose }) => {
  return (
    <Modal show={show} size="lg" centered onHide={onClose}>
      <Modal.Body>
        <div className="modal__wrapper">
          <div className="inner__modal">
            <div className="replace__modal text-center">
              <div className="replace__icon mb-3">
                <img src="/img/modalwarn.svg" alt="modalwarn" />
              </div>

              <h6>Are you sure you want to clone this Corporate Order?</h6>

              <div className="replace__buttons mt-4 d-flex justify-content-center gap-3">
                <button
                  type="button"
                  className="replace__confirm"
                  onClick={onConfirm}
                >
                  Yes
                </button>

                <button
                  type="button"
                  className="close__replace"
                  onClick={onClose}
                >
                  No
                </button>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ModalCloneConfirmation;
